module.exports = __webpack_public_path__ + "static/media/paid-social.1fbaff26.svg";